import React, { useState, useRef, useEffect } from 'react';
import { Box } from '@mui/material';

const CustomMagnifier = ({
  src,
  alt = 'image',
  style = {},
  mgWidth = 200,
  mgHeight = 200,
  zoomFactor = 1.5,
  className = '',
  ...props
}) => {
  const [isZoomed, setIsZoomed] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [imageSize, setImageSize] = useState({ width: 0, height: 0 });
  const imageRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    const updateImageSize = () => {
      if (imageRef.current) {
        const rect = imageRef.current.getBoundingClientRect();
        setImageSize({ width: rect.width, height: rect.height });
      }
    };

    updateImageSize();
    window.addEventListener('resize', updateImageSize);
    return () => window.removeEventListener('resize', updateImageSize);
  }, [src]);

  const handleMouseEnter = () => {
    setIsZoomed(true);
  };

  const handleMouseLeave = () => {
    setIsZoomed(false);
  };

  const handleMouseMove = (e) => {
    if (!containerRef.current) return;
    
    const rect = containerRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    
    setMousePosition({ x, y });
  };

  const magnifierStyle = {
    position: 'absolute',
    width: mgWidth,
    height: mgHeight,
    border: '2px solid #ccc',
    borderRadius: '50%',
    background: `url(${src}) no-repeat`,
    backgroundSize: `${imageSize.width * zoomFactor}px ${imageSize.height * zoomFactor}px`,
    backgroundPosition: `-${mousePosition.x * zoomFactor - mgWidth / 2}px -${mousePosition.y * zoomFactor - mgHeight / 2}px`,
    pointerEvents: 'none',
    left: mousePosition.x - mgWidth / 2,
    top: mousePosition.y - mgHeight / 2,
    zIndex: 1000,
    boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
  };

  return (
    <Box
      ref={containerRef}
      className={className}
      style={{
        position: 'relative',
        display: 'inline-block',
        cursor: 'zoom-in',
        ...style,
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onMouseMove={handleMouseMove}
      {...props}
    >
      <img
        ref={imageRef}
        src={src}
        alt={alt}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          display: 'block',
        }}
        onLoad={() => {
          if (imageRef.current) {
            const rect = imageRef.current.getBoundingClientRect();
            setImageSize({ width: rect.width, height: rect.height });
          }
        }}
      />
      {isZoomed && (
        <div style={magnifierStyle} />
      )}
    </Box>
  );
};

export default CustomMagnifier;